module.exports = __webpack_public_path__ + "static/media/221HO.9046bdc2.jpg";